export default [{
    path: '/card',
    component: () => import('@/views/setting/card-management')
},{
    path: '/cardUser',
    component: () => import('@/views/setting/card-user')
},{
    path: '/cardNumUser',
    component: () => import('@/views/setting/card-num-user')
}]